__turbopack_context__.v({
  "__title": "group-hero-module-scss-module__ViAGGG____title",
  "group-hero": "group-hero-module-scss-module__ViAGGG__group-hero",
});
